import { ApolloError, LazyQueryResult, useLazyQuery, useQuery } from '@apollo/client'

import { Form, QueryFormArgs } from '@types'

import { FORM } from '@libs/apollo/queries/form.query'

interface Data {
  form?: Form
}

export const useForm = (
  id: string,
): {
  loading: boolean
  error: ApolloError | undefined
  refetch: (id: string) => void
  data?: Data
} => {
  const { refetch, loading, error, data } = useQuery<Data, QueryFormArgs>(FORM, {
    variables: {
      id,
    },
    skip: id === '',
    notifyOnNetworkStatusChange: true,
  })

  const refetchData = (id: string) => {
    try {
      const variables: QueryFormArgs = {
        id,
      }
      refetch(variables)
    } catch (error) {
      console.error(error)
    }
  }

  return { loading, error, data, refetch: refetchData }
}

export const useLazyForm = (): {
  loading: boolean
  error: ApolloError | undefined
  refetch: (id: string) => void
  getData: (id: string) => Promise<LazyQueryResult<Data, QueryFormArgs>>
  data?: Data
} => {
  const [getData, { loading, error, data, refetch }] = useLazyQuery<Data, QueryFormArgs>(FORM, {
    notifyOnNetworkStatusChange: true,
  })

  const _getData = async (id: string): Promise<LazyQueryResult<Data, QueryFormArgs>> => {
    try {
      const variables: QueryFormArgs = {
        id,
      }
      return getData({ variables })
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  const refetchData = (id: string) => {
    try {
      const variables: QueryFormArgs = {
        id,
      }
      refetch(variables)
    } catch (error) {
      console.error(error)
    }
  }

  return { loading, error, data, getData: _getData, refetch: refetchData }
}
